import { yup } from '@guiker/yup-util'

export const consentClaimsSchema = yup.object({
  userId: yup.string().required(),
  email: yup.string().required(),
})
